import React, { createContext, useCallback, useContext, useState } from 'react';
import { MessageInfoContext } from './MessageInfoContextProvider';

export type MessageKindType = 'help' | 'message' | 'placeInfo' | 'none';

type DialogStateType = {
  isOpen: boolean;
  kind: MessageKindType;
  selectedPlace: string; //選択された車両アイコンの属する領域
  selectedTrain: number; //選択された車両アイコンの領域内でのインデックス
};

const initialState: DialogStateType = {
  isOpen: false,
  kind: 'none',
  selectedPlace: '',
  selectedTrain: 0
};

type DialogStateContextType = {
  dialogState: DialogStateType;
  closeDialog: () => void; //ダイアログを閉じる関数
  openDialog: (
    kind: MessageKindType,
    selectedPlace?: string,
    selectedTrain?: number
  ) => void; //ダイアログを開く関数
};

export const DialogStateContext = createContext({} as DialogStateContextType);

type Props = {
  children: React.ReactNode;
};

// ダイアログに関する状態を記憶するContext
export const DialogStateContextProvider: React.FC<Props> = (props) => {
  const { info, setInfo } = useContext(MessageInfoContext);
  const [dialogState, setDialogState] = useState(initialState);

  const closeDialog = useCallback(() => {
    // 一度ダイアログを閉じた後は強制ポップアップ表示をOFFに
    if (dialogState.kind === 'message' && !info.failedGetMessage) {
      setInfo((pre) => ({
        ...pre,
        isFirst: false
      }));
    }
    setDialogState({
      isOpen: false,
      kind: 'none',
      selectedPlace: '',
      selectedTrain: -1
    });
  }, [dialogState.kind, info.failedGetMessage, setInfo]);

  const openDialog = useCallback(
    (kind: MessageKindType, selectedPlace = '', selectedTrain = 0) => {
      setDialogState({
        isOpen: true,
        kind: kind,
        selectedPlace: selectedPlace,
        selectedTrain: selectedTrain
      });
    },
    [setDialogState]
  );

  return (
    <DialogStateContext.Provider
      value={{
        dialogState,
        closeDialog,
        openDialog
      }}
    >
      {props.children}
    </DialogStateContext.Provider>
  );
};
